module.exports = __webpack_public_path__ + "static/media/carousel4.5fe5e82c.jpeg";